import type { Theme } from "../types";

/** Dark themes: catppuccin-mocha through kanagawa */
export const bundle03: Theme[] = [
  {
    colors: {
      accent: "oklch(0.36 0.028 285)",
      accentForeground: "oklch(0.9 0.01 290)",
      background: "oklch(0.22 0.02 285)",
      border: "oklch(1 0 0 / 10%)",
      card: "oklch(0.26 0.022 285)",
      cardForeground: "oklch(0.9 0.01 290)",
      chartColors: [
        "oklch(0.75 0.14 305)",
        "oklch(0.8 0.12 340)",
        "oklch(0.7 0.16 215)",
        "oklch(0.78 0.15 140)",
        "oklch(0.72 0.18 85)",
      ],
      destructive: "oklch(0.65 0.2 15)",
      foreground: "oklch(0.9 0.01 290)",
      input: "oklch(1 0 0 / 15%)",
      muted: "oklch(0.32 0.025 285)",
      mutedForeground: "oklch(0.6 0.02 290)",
      popover: "oklch(0.26 0.022 285)",
      popoverForeground: "oklch(0.9 0.01 290)",
      primary: "oklch(0.75 0.14 305)",
      primaryForeground: "oklch(0.2 0.02 285)",
      ring: "oklch(0.75 0.14 305)",
      secondary: "oklch(0.32 0.025 285)",
      secondaryForeground: "oklch(0.9 0.01 290)",
      sidebar: "oklch(0.2 0.02 285)",
      sidebarAccent: "oklch(0.36 0.028 285)",
      sidebarAccentForeground: "oklch(0.9 0.01 290)",
      sidebarBorder: "oklch(1 0 0 / 10%)",
      sidebarForeground: "oklch(0.9 0.01 290)",
      sidebarPrimary: "oklch(0.75 0.14 305)",
      sidebarPrimaryForeground: "oklch(0.2 0.02 285)",
      sidebarRing: "oklch(0.75 0.14 305)",
    },
    isDark: true,
    label: "Catppuccin Mocha",
    name: "catppuccin-mocha",
    pair: "lavender-light",
    swatches: ["#1e1e2e", "#cba6f7", "#f5c2e7", "#313244"],
  },
  {
    colors: {
      accent: "oklch(0.32 0.03 290)",
      accentForeground: "oklch(0.88 0.015 300)",
      background: "oklch(0.19 0.02 290)",
      border: "oklch(1 0 0 / 10%)",
      card: "oklch(0.23 0.022 290)",
      cardForeground: "oklch(0.88 0.015 300)",
      chartColors: [
        "oklch(0.65 0.19 5)",
        "oklch(0.75 0.12 305)",
        "oklch(0.72 0.14 200)",
        "oklch(0.78 0.14 85)",
        "oklch(0.6 0.15 260)",
      ],
      destructive: "oklch(0.65 0.19 5)",
      foreground: "oklch(0.88 0.015 300)",
      input: "oklch(1 0 0 / 15%)",
      muted: "oklch(0.28 0.025 290)",
      mutedForeground: "oklch(0.58 0.02 295)",
      popover: "oklch(0.23 0.022 290)",
      popoverForeground: "oklch(0.88 0.015 300)",
      primary: "oklch(0.65 0.19 5)",
      primaryForeground: "oklch(0.17 0.02 290)",
      ring: "oklch(0.75 0.12 305)",
      secondary: "oklch(0.28 0.025 290)",
      secondaryForeground: "oklch(0.88 0.015 300)",
      sidebar: "oklch(0.17 0.02 290)",
      sidebarAccent: "oklch(0.32 0.03 290)",
      sidebarAccentForeground: "oklch(0.88 0.015 300)",
      sidebarBorder: "oklch(1 0 0 / 10%)",
      sidebarForeground: "oklch(0.88 0.015 300)",
      sidebarPrimary: "oklch(0.65 0.19 5)",
      sidebarPrimaryForeground: "oklch(0.17 0.02 290)",
      sidebarRing: "oklch(0.75 0.12 305)",
    },
    isDark: true,
    label: "Rosé Pine",
    name: "rose-pine-dark",
    pair: "rose-light",
    swatches: ["#191724", "#eb6f92", "#c4a7e7", "#26233a"],
  },
  {
    colors: {
      accent: "oklch(0.28 0.035 265)",
      accentForeground: "oklch(0.85 0.01 140)",
      background: "oklch(0.15 0.02 265)",
      border: "oklch(1 0 0 / 8%)",
      card: "oklch(0.19 0.025 265)",
      cardForeground: "oklch(0.85 0.01 140)",
      chartColors: [
        "oklch(0.7 0.2 145)",
        "oklch(0.6 0.12 195)",
        "oklch(0.65 0.18 270)",
        "oklch(0.75 0.15 85)",
        "oklch(0.6 0.22 330)",
      ],
      destructive: "oklch(0.65 0.2 15)",
      foreground: "oklch(0.85 0.01 140)",
      input: "oklch(1 0 0 / 12%)",
      muted: "oklch(0.24 0.03 265)",
      mutedForeground: "oklch(0.55 0.015 265)",
      popover: "oklch(0.19 0.025 265)",
      popoverForeground: "oklch(0.85 0.01 140)",
      primary: "oklch(0.7 0.2 145)",
      primaryForeground: "oklch(0.13 0.02 265)",
      ring: "oklch(0.7 0.2 145)",
      secondary: "oklch(0.24 0.03 265)",
      secondaryForeground: "oklch(0.85 0.01 140)",
      sidebar: "oklch(0.13 0.02 265)",
      sidebarAccent: "oklch(0.28 0.035 265)",
      sidebarAccentForeground: "oklch(0.85 0.01 140)",
      sidebarBorder: "oklch(1 0 0 / 8%)",
      sidebarForeground: "oklch(0.85 0.01 140)",
      sidebarPrimary: "oklch(0.7 0.2 145)",
      sidebarPrimaryForeground: "oklch(0.13 0.02 265)",
      sidebarRing: "oklch(0.7 0.2 145)",
    },
    isDark: true,
    label: "Midnight",
    name: "midnight",
    pair: "botanical-light",
    swatches: ["#0f0f23", "#00cc00", "#009999", "#1a1a40"],
  },
  {
    colors: {
      accent: "oklch(0.37 0.018 55)",
      accentForeground: "oklch(0.9 0.04 85)",
      background: "oklch(0.24 0.015 65)",
      border: "oklch(1 0 0 / 10%)",
      card: "oklch(0.28 0.015 55)",
      cardForeground: "oklch(0.9 0.04 85)",
      chartColors: [
        "oklch(0.62 0.24 25)",
        "oklch(0.75 0.17 135)",
        "oklch(0.78 0.16 85)",
        "oklch(0.6 0.15 250)",
        "oklch(0.7 0.2 55)",
      ],
      destructive: "oklch(0.62 0.24 25)",
      foreground: "oklch(0.9 0.04 85)",
      input: "oklch(1 0 0 / 15%)",
      muted: "oklch(0.33 0.015 55)",
      mutedForeground: "oklch(0.65 0.03 80)",
      popover: "oklch(0.28 0.015 55)",
      popoverForeground: "oklch(0.9 0.04 85)",
      primary: "oklch(0.9 0.04 85)",
      primaryForeground: "oklch(0.24 0.015 65)",
      ring: "oklch(0.75 0.12 80)",
      secondary: "oklch(0.33 0.015 55)",
      secondaryForeground: "oklch(0.9 0.04 85)",
      sidebar: "oklch(0.22 0.015 65)",
      sidebarAccent: "oklch(0.37 0.018 55)",
      sidebarAccentForeground: "oklch(0.9 0.04 85)",
      sidebarBorder: "oklch(1 0 0 / 10%)",
      sidebarForeground: "oklch(0.9 0.04 85)",
      sidebarPrimary: "oklch(0.9 0.04 85)",
      sidebarPrimaryForeground: "oklch(0.22 0.015 65)",
      sidebarRing: "oklch(0.75 0.12 80)",
    },
    isDark: true,
    label: "Gruvbox Dark",
    name: "gruvbox-dark",
    pair: "tangerine",
    swatches: ["#282828", "#ebdbb2", "#fb4934", "#3c3836"],
  },
  {
    colors: {
      accent: "oklch(0.33 0.035 270)",
      accentForeground: "oklch(0.88 0.015 260)",
      background: "oklch(0.18 0.02 270)",
      border: "oklch(1 0 0 / 10%)",
      card: "oklch(0.22 0.025 270)",
      cardForeground: "oklch(0.88 0.015 260)",
      chartColors: [
        "oklch(0.7 0.17 260)",
        "oklch(0.72 0.15 300)",
        "oklch(0.75 0.16 195)",
        "oklch(0.78 0.15 85)",
        "oklch(0.65 0.2 350)",
      ],
      destructive: "oklch(0.65 0.2 15)",
      foreground: "oklch(0.88 0.015 260)",
      input: "oklch(1 0 0 / 15%)",
      muted: "oklch(0.28 0.03 270)",
      mutedForeground: "oklch(0.55 0.02 265)",
      popover: "oklch(0.22 0.025 270)",
      popoverForeground: "oklch(0.88 0.015 260)",
      primary: "oklch(0.7 0.17 260)",
      primaryForeground: "oklch(0.16 0.02 270)",
      ring: "oklch(0.7 0.17 260)",
      secondary: "oklch(0.28 0.03 270)",
      secondaryForeground: "oklch(0.88 0.015 260)",
      sidebar: "oklch(0.16 0.02 270)",
      sidebarAccent: "oklch(0.33 0.035 270)",
      sidebarAccentForeground: "oklch(0.88 0.015 260)",
      sidebarBorder: "oklch(1 0 0 / 10%)",
      sidebarForeground: "oklch(0.88 0.015 260)",
      sidebarPrimary: "oklch(0.7 0.17 260)",
      sidebarPrimaryForeground: "oklch(0.16 0.02 270)",
      sidebarRing: "oklch(0.7 0.17 260)",
    },
    isDark: true,
    label: "Tokyo Night",
    name: "tokyo-night",
    pair: "ocean-light",
    swatches: ["#1a1b26", "#7aa2f7", "#bb9af7", "#24283b"],
  },
  {
    colors: {
      accent: "oklch(0.26 0.035 300)",
      accentForeground: "oklch(0.9 0.01 310)",
      background: "oklch(0.14 0.02 300)",
      border: "oklch(1 0 0 / 8%)",
      card: "oklch(0.18 0.025 300)",
      cardForeground: "oklch(0.9 0.01 310)",
      chartColors: [
        "oklch(0.7 0.3 325)",
        "oklch(0.8 0.2 195)",
        "oklch(0.75 0.22 85)",
        "oklch(0.65 0.25 290)",
        "oklch(0.6 0.2 20)",
      ],
      destructive: "oklch(0.65 0.2 15)",
      foreground: "oklch(0.9 0.01 310)",
      input: "oklch(1 0 0 / 12%)",
      muted: "oklch(0.22 0.03 300)",
      mutedForeground: "oklch(0.55 0.02 310)",
      popover: "oklch(0.18 0.025 300)",
      popoverForeground: "oklch(0.9 0.01 310)",
      primary: "oklch(0.7 0.3 325)",
      primaryForeground: "oklch(0.12 0.02 300)",
      ring: "oklch(0.8 0.2 195)",
      secondary: "oklch(0.22 0.03 300)",
      secondaryForeground: "oklch(0.9 0.01 310)",
      sidebar: "oklch(0.12 0.02 300)",
      sidebarAccent: "oklch(0.26 0.035 300)",
      sidebarAccentForeground: "oklch(0.9 0.01 310)",
      sidebarBorder: "oklch(1 0 0 / 8%)",
      sidebarForeground: "oklch(0.9 0.01 310)",
      sidebarPrimary: "oklch(0.7 0.3 325)",
      sidebarPrimaryForeground: "oklch(0.12 0.02 300)",
      sidebarRing: "oklch(0.8 0.2 195)",
    },
    isDark: true,
    label: "Cyberpunk",
    name: "cyber-punk",
    pair: "rose-light",
    swatches: ["#0d0d1a", "#ff00ff", "#00ffff", "#1a0033"],
  },
  {
    colors: {
      accent: "oklch(0.36 0.04 205)",
      accentForeground: "oklch(0.65 0.02 195)",
      background: "oklch(0.24 0.04 205)",
      border: "oklch(1 0 0 / 10%)",
      card: "oklch(0.27 0.04 205)",
      cardForeground: "oklch(0.65 0.02 195)",
      chartColors: [
        "oklch(0.65 0.12 190)",
        "oklch(0.56 0.14 240)",
        "oklch(0.6 0.17 145)",
        "oklch(0.7 0.16 70)",
        "oklch(0.58 0.16 300)",
      ],
      destructive: "oklch(0.55 0.2 25)",
      foreground: "oklch(0.65 0.02 195)",
      input: "oklch(1 0 0 / 15%)",
      muted: "oklch(0.32 0.04 205)",
      mutedForeground: "oklch(0.52 0.02 200)",
      popover: "oklch(0.27 0.04 205)",
      popoverForeground: "oklch(0.65 0.02 195)",
      primary: "oklch(0.65 0.12 190)",
      primaryForeground: "oklch(0.2 0.04 205)",
      ring: "oklch(0.65 0.12 190)",
      secondary: "oklch(0.32 0.04 205)",
      secondaryForeground: "oklch(0.65 0.02 195)",
      sidebar: "oklch(0.22 0.04 205)",
      sidebarAccent: "oklch(0.36 0.04 205)",
      sidebarAccentForeground: "oklch(0.65 0.02 195)",
      sidebarBorder: "oklch(1 0 0 / 10%)",
      sidebarForeground: "oklch(0.65 0.02 195)",
      sidebarPrimary: "oklch(0.65 0.12 190)",
      sidebarPrimaryForeground: "oklch(0.2 0.04 205)",
      sidebarRing: "oklch(0.65 0.12 190)",
    },
    isDark: true,
    label: "Solarized Dark",
    name: "solarized-dark",
    pair: "solarized-light",
    swatches: ["#002b36", "#839496", "#2aa198", "#073642"],
  },
  {
    colors: {
      accent: "oklch(0.28 0.025 250)",
      accentForeground: "oklch(0.82 0.02 80)",
      background: "oklch(0.15 0.015 250)",
      border: "oklch(1 0 0 / 8%)",
      card: "oklch(0.19 0.018 250)",
      cardForeground: "oklch(0.82 0.02 80)",
      chartColors: [
        "oklch(0.78 0.14 80)",
        "oklch(0.65 0.14 225)",
        "oklch(0.6 0.2 20)",
        "oklch(0.72 0.15 300)",
        "oklch(0.7 0.18 145)",
      ],
      destructive: "oklch(0.62 0.2 20)",
      foreground: "oklch(0.82 0.02 80)",
      input: "oklch(1 0 0 / 12%)",
      muted: "oklch(0.24 0.02 250)",
      mutedForeground: "oklch(0.5 0.015 250)",
      popover: "oklch(0.19 0.018 250)",
      popoverForeground: "oklch(0.82 0.02 80)",
      primary: "oklch(0.78 0.14 80)",
      primaryForeground: "oklch(0.13 0.015 250)",
      ring: "oklch(0.65 0.14 225)",
      secondary: "oklch(0.24 0.02 250)",
      secondaryForeground: "oklch(0.82 0.02 80)",
      sidebar: "oklch(0.13 0.015 250)",
      sidebarAccent: "oklch(0.28 0.025 250)",
      sidebarAccentForeground: "oklch(0.82 0.02 80)",
      sidebarBorder: "oklch(1 0 0 / 8%)",
      sidebarForeground: "oklch(0.82 0.02 80)",
      sidebarPrimary: "oklch(0.78 0.14 80)",
      sidebarPrimaryForeground: "oklch(0.13 0.015 250)",
      sidebarRing: "oklch(0.65 0.14 225)",
    },
    isDark: true,
    label: "Ayu Dark",
    name: "ayu-dark",
    pair: "serika-light",
    swatches: ["#0d1017", "#e6b450", "#39bae6", "#131721"],
  },
  {
    colors: {
      accent: "oklch(0.39 0.02 170)",
      accentForeground: "oklch(0.85 0.02 140)",
      background: "oklch(0.27 0.015 170)",
      border: "oklch(1 0 0 / 10%)",
      card: "oklch(0.3 0.015 170)",
      cardForeground: "oklch(0.85 0.02 140)",
      chartColors: [
        "oklch(0.76 0.1 130)",
        "oklch(0.7 0.08 160)",
        "oklch(0.65 0.17 20)",
        "oklch(0.72 0.12 80)",
        "oklch(0.68 0.14 285)",
      ],
      destructive: "oklch(0.65 0.17 20)",
      foreground: "oklch(0.85 0.02 140)",
      input: "oklch(1 0 0 / 15%)",
      muted: "oklch(0.35 0.018 170)",
      mutedForeground: "oklch(0.6 0.015 160)",
      popover: "oklch(0.3 0.015 170)",
      popoverForeground: "oklch(0.85 0.02 140)",
      primary: "oklch(0.76 0.1 130)",
      primaryForeground: "oklch(0.22 0.015 170)",
      ring: "oklch(0.76 0.1 130)",
      secondary: "oklch(0.35 0.018 170)",
      secondaryForeground: "oklch(0.85 0.02 140)",
      sidebar: "oklch(0.25 0.015 170)",
      sidebarAccent: "oklch(0.39 0.02 170)",
      sidebarAccentForeground: "oklch(0.85 0.02 140)",
      sidebarBorder: "oklch(1 0 0 / 10%)",
      sidebarForeground: "oklch(0.85 0.02 140)",
      sidebarPrimary: "oklch(0.76 0.1 130)",
      sidebarPrimaryForeground: "oklch(0.22 0.015 170)",
      sidebarRing: "oklch(0.76 0.1 130)",
    },
    isDark: true,
    label: "Everforest",
    name: "everforest-dark",
    pair: "botanical-light",
    swatches: ["#2d353b", "#a7c080", "#83c092", "#343f44"],
  },
  {
    colors: {
      accent: "oklch(0.33 0.025 275)",
      accentForeground: "oklch(0.88 0.025 85)",
      background: "oklch(0.2 0.015 275)",
      border: "oklch(1 0 0 / 10%)",
      card: "oklch(0.24 0.018 275)",
      cardForeground: "oklch(0.88 0.025 85)",
      chartColors: [
        "oklch(0.68 0.1 250)",
        "oklch(0.72 0.15 195)",
        "oklch(0.6 0.2 15)",
        "oklch(0.75 0.12 85)",
        "oklch(0.65 0.14 310)",
      ],
      destructive: "oklch(0.6 0.2 15)",
      foreground: "oklch(0.88 0.025 85)",
      input: "oklch(1 0 0 / 15%)",
      muted: "oklch(0.29 0.02 275)",
      mutedForeground: "oklch(0.58 0.015 270)",
      popover: "oklch(0.24 0.018 275)",
      popoverForeground: "oklch(0.88 0.025 85)",
      primary: "oklch(0.68 0.1 250)",
      primaryForeground: "oklch(0.18 0.015 275)",
      ring: "oklch(0.68 0.1 250)",
      secondary: "oklch(0.29 0.02 275)",
      secondaryForeground: "oklch(0.88 0.025 85)",
      sidebar: "oklch(0.18 0.015 275)",
      sidebarAccent: "oklch(0.33 0.025 275)",
      sidebarAccentForeground: "oklch(0.88 0.025 85)",
      sidebarBorder: "oklch(1 0 0 / 10%)",
      sidebarForeground: "oklch(0.88 0.025 85)",
      sidebarPrimary: "oklch(0.68 0.1 250)",
      sidebarPrimaryForeground: "oklch(0.18 0.015 275)",
      sidebarRing: "oklch(0.68 0.1 250)",
    },
    isDark: true,
    label: "Kanagawa",
    name: "kanagawa",
    pair: "paper",
    swatches: ["#1f1f28", "#dcd7ba", "#7e9cd8", "#2a2a37"],
  },
];
